module.exports = __webpack_public_path__ + "img/book1.a75b0c71.png";